export default class SurveysAccessesEdit {

  constructor() {}

  render() {

    // On toggle
    $('.custom-control-input').change(function() {
      if ($(this).is(":checked")) {
        let url = $(this).attr('data-create-url');
        $.ajax({
          type: 'POST',
          dataType: 'application/json',
          url: url
        });
      } else {
        let url = $(this).attr('data-delete-url');
        $.ajax({
          type: 'DELETE',
          dataType: 'application/json',
          url: url
        });
      }          
    })


  }
}
